module.exports = __webpack_public_path__ + "static/media/TitlesBadOptimized.3b2a52cc.webp";